import { Navigate, useLocation } from "react-router-dom";
import { usePersistStore } from "../../store";
import { setPostLoginRedirect } from "../../utils/postLoginRedirect";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, token } = usePersistStore((s: any) => s);
  const location = useLocation();
  const authenticated = user && token;

  if (!authenticated) {
    setPostLoginRedirect(`${location.pathname}${location.search || ""}`);
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
